var TECL_TagsAndMetadataForm = {

    Initialise: function() {
        $(document).ready(function() {

            $('#courseAlerts').hide();

            $("input[name='Tags[0].Value'][value='Course Alert']").on("change", function() {
                if ($(this).is(':checked')) {
                    $('#courseAlerts').show();
                    $('#courseAlerts').addClass('checkbox-group');
                    $('#courseAlerts').addClass('required');
                } else {
                    $('#courseAlerts').hide();
                    $('#courseAlerts').removeClass('checkbox-group');
                    $('#courseAlerts').removeClass('required');
                }
            });

            $(".select-all").on("click", function(e) {
                e.preventDefault();
                $(this).parent().find("input:checkbox").prop('checked', true);
            });

            $("#metadataForm").submit(function(event) {
                $(":input[type='text'][required]").each(function() {

                    if ($(this).val() == "") {
                        if ($(this).prev().hasClass("alert")) {
                            $(this).prev(".alert").text("You must fill in this field.");
                        } else {
                            $(this).before('<div class="alert alert-danger" role="alert">You must fill in this field.</div>');
                        }
                        $(this).addClass("has-error");
                        event.preventDefault();
                    } else {
                        if ($(this).prev().hasClass("alert")) {
                            $(this).prev().remove();
                            $(this).removeClass("has-error");
                        }
                    }
                });

                $('div.checkbox-group.required').each(function() {
                    if ($(this).find("input[type='checkbox']:checked").length == 0) {
                        if ($(this).children(".alert").length > 0) {
                            $(this).children(".alert").text("You must tick at least one box in this group.");
                        } else {
                            $(this).prepend('<div class="alert alert-danger" role="alert">You must tick at least one box in this group.</div>');
                        }
                        $(this).addClass("has-error");
                        event.preventDefault();
                    } else {
                        $(this).children(".alert").remove();
                        $(this).removeClass("has-error");
                    }
                });
            });
        });
    }
};
